@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/metadata-tab/clipping-studio-metadata-tab.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.metadata-tab {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-bottom: 5rem;
}
.metadata-tab__source-block {
  background: rgb(235, 240, 244);
  border: 1px solid rgb(226, 232, 241);
  border-radius: 12px;
  padding: 1rem;
  position: relative;
  overflow: hidden;
}
.metadata-tab__source-lines {
  margin-bottom: 12px;
}
.metadata-tab__source-line {
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.metadata-tab__source-line:not(:last-child) {
  margin-bottom: 6px;
}
.metadata-tab__source-value {
  color: rgba(0, 0, 0, 0.85);
  text-transform: none;
}
.metadata-tab__source-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.metadata-tab__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  border: none;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  transition: background-color 0.2s ease, opacity 0.15s ease;
  box-sizing: border-box;
}
.metadata-tab__btn:focus {
  outline: none;
  box-shadow: none;
}
.metadata-tab__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.metadata-tab__btn--ai {
  padding: 8px 16px;
  height: 44px;
  border-radius: 6px;
  color: rgb(255, 255, 255);
  background-color: rgb(45, 187, 252);
}
.metadata-tab__btn--ai:hover:not(:disabled) {
  background-color: rgb(41, 170, 229);
}
.metadata-tab__spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: rgb(255, 255, 255);
  border-radius: 50%;
  animation: metadata-tab-spin 0.6s linear infinite;
}
@keyframes metadata-tab-spin {
  to {
    transform: rotate(360deg);
  }
}
.metadata-tab__section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.metadata-tab__section--border {
  padding-top: 0.75rem;
  border-top: 1px solid rgb(226, 232, 241);
}
.metadata-tab__label {
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.metadata-tab__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.metadata-tab__label-row-main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.metadata-tab__modified {
  font-size: 10px;
  font-weight: 700;
  color: rgb(163, 115, 0);
  background: rgb(255, 221, 171);
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid rgb(255, 180, 0);
}
.metadata-tab__override,
.metadata-tab__override-badge {
  font-size: 10px;
  font-weight: 700;
  color: rgb(45, 187, 252);
  background: rgba(45, 187, 252, 0.12);
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid rgb(45, 187, 252);
}
.metadata-tab__reset-link {
  font-size: 11px;
  font-weight: 600;
  color: rgb(45, 187, 252);
  text-decoration: none;
}
.metadata-tab__reset-link:hover {
  text-decoration: underline;
}
.metadata-tab__preview {
  position: relative;
  aspect-ratio: 16/9;
  background: rgb(35, 47, 58);
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgb(226, 232, 241);
  cursor: pointer;
}
.metadata-tab__preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.metadata-tab__preview-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-style: italic;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  background: rgb(235, 240, 244);
}
.metadata-tab__preview-duration {
  position: absolute;
  bottom: 8px;
  right: 8px;
  padding: 2px 6px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  font-size: 10px;
  font-family: monospace;
  color: rgb(255, 255, 255);
}
.metadata-tab__hint {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  font-style: italic;
  margin: 0;
}
.metadata-tab__input {
  width: 100%;
  height: 44px;
  padding: 10px 12px;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.85);
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  box-sizing: border-box;
  outline: none;
}
.metadata-tab__input:focus {
  outline: none;
  border-color: rgb(22, 177, 255);
}
.metadata-tab__input::placeholder {
  color: rgba(0, 0, 0, 0.54);
}
.metadata-tab__input--modified {
  border-color: rgb(255, 180, 0);
  background: rgba(255, 180, 0, 0.08);
}
.metadata-tab__input--sm {
  height: auto;
  min-height: 0;
  padding: 8px 10px;
  font-size: 11px;
}
.metadata-tab__char-count {
  margin: 0;
  flex-shrink: 0;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
  text-align: right;
}
.metadata-tab__char-count--error {
  color: #ef5350;
  font-weight: 600;
}
.metadata-tab__textarea {
  width: 100%;
  min-height: 72px;
  padding: 10px 12px;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.85);
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  box-sizing: border-box;
  outline: none;
  resize: none;
}
.metadata-tab__textarea:focus {
  outline: none;
  border-color: rgb(22, 177, 255);
}
.metadata-tab__textarea::placeholder {
  color: rgba(0, 0, 0, 0.54);
}
.metadata-tab__textarea.metadata-tab__input--modified {
  border-color: rgb(255, 180, 0);
  background: rgba(255, 180, 0, 0.08);
}
.metadata-tab__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.metadata-tab__select {
  width: 100%;
  padding: 12px 32px 12px 12px;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 14px;
  font-weight: 500;
  background: rgb(235, 240, 244);
  border: 1px solid rgb(226, 232, 241);
  border-radius: 6px;
  appearance: none;
  outline: none;
  cursor: pointer;
  pointer-events: auto;
}
.metadata-tab__select:focus {
  box-shadow: 0 0 0 2px rgb(45, 187, 252);
  background: rgb(255, 255, 255);
}
.metadata-tab__select--sm {
  padding: 8px 28px 8px 10px;
  font-size: 11px;
  border-radius: 6px;
}
.metadata-tab__visibility {
  display: flex;
  gap: 8px;
}
.metadata-tab__visibility-btn {
  flex: 1;
  padding: 8px;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  font-weight: 700;
  border-radius: 6px;
  border: 1px solid rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  transition:
    background 0.15s,
    border-color 0.15s,
    color 0.15s;
}
.metadata-tab__visibility-btn:hover {
  border-color: rgb(45, 187, 252);
}
.metadata-tab__visibility-btn--active {
  background: rgb(45, 187, 252);
  color: rgb(255, 255, 255);
  border-color: rgb(45, 187, 252);
}
.metadata-tab__spacer {
  height: 2rem;
}
/*# sourceMappingURL=clipping-studio-metadata-tab.component.css.map */
